<template>
  <div>
    <div class="y-form-group">
      <el-row class="y-form-group-header">
        <el-col class="y-form-group-header__icon icon-setup-env" :span="4">&nbsp;</el-col>
        <el-col
          class="y-form-group-header__text"
          :span="20"
        >{{ $lang.messages.setup_header_environment }}</el-col>
      </el-row>
      <div class="y-form-item-group">
        <div class="y-form-row y-form-row__fullwidth">
          <label
            class="y-form-label y-form-label__heavy"
            :class="!isEditFlow ? 'is-required' : ''"
          >{{ $lang.messages.form_label_customer_name }}</label>
          <template v-if="!isEditFlow">
            <el-input
              v-model="setupTemplateData.name"
              placeholder="letters, numbers, dashes, spaces"
              class="y-form-input y-form-input__small"
              :class="errors.first('name') ? 'y-form-input-error':''"
              style="width:300px"
              data-vv-validate-on="change"
              data-vv-name="name"
              data-vv-as="Name"
              v-validate="{required:true, min: 2, max:50, alpha_num_dash_spaces: true}"
            ></el-input>
            <span class="y-form-error errorField" v-show="errors.first('name')">
              <i class="el-icon-warning"></i>
              {{ errors.first('name') }}
            </span>
          </template>
          <template v-if="isEditFlow">
            <span class="y-form-inline-data">{{setupTemplateData.name}}</span>
          </template>
        </div>

        <div class="y-form-row y-form-row__fullwidth clearfix">
          <label
            class="y-form-label y-form-label__heavy is-required"
          >{{ $lang.messages.form_label_domain_name }}</label>
          <div class="y-form-pre-post-ctr">
            <span class="y-form-pre-text"></span>
            <el-input
              v-model="setupTemplateData.appext"
              placeholder="letters, numbers, dashes"
              class="y-form-input y-form-input__small"
              :class="errors.first('appext') ? 'y-form-input-error':''"
              style="width:300px"
              data-vv-validate-on="change"
              data-vv-name="appext"
              data-vv-as="App Ext"
              v-validate="{required:true, min: 2, max:50, alpha_num_dash: true}"
            ></el-input>
            <span class="y-form-post-text"></span>
          </div>
          <span class="y-form-error errorField" v-show="errors.first('appext')">
            <i class="el-icon-warning"></i>
            {{ errors.first('appext') }}
          </span>
        </div>
        <div class="y-form-row y-form-row__fullwidth">
          <y-add-ip-address :data="ipAddressCompData" @update="getIpAddress" />
        </div>
        <el-button class="y-button" @click="saveEnv">Save</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import addIpAddress from '../../components/yAddInputList.vue'
import serviceRegistery from '../../mixins/serviceRegistery'
export default {
  name: 'SetupEnv',
  inject: ['$validator'],
  components: {
    'y-add-ip-address': addIpAddress
  },
  props: {
    data: Object
  },
  data() {
    return {
      isEditFlow: this.data.isEditFlow,
      ipAddressCompData: {
        label: this.$lang.messages.form_label_ip_addresses,
        errorMsgLabel: 'IP address',
        is_required: false,
        dataList: this.setIpAddressValues(),
        maxListCount: 5,
        placeholderText: this.$lang.messages.form_placeholder_ip_addresses,
        validationRule: {
          required: false,
          ip: true,
          max: 50
        }
      },
      ipAddresses: []
    }
  },
  computed: {
    setupTemplateData() {
      return this.$store.state.createSubbrandStore.setupTemplateData
    }
  },
  created() {},
  methods: {
    getIpAddress(ipList) {
      console.log('ipAddresses -->', ipList)
      this.ipAddresses = ipList
    },
    setIpAddressValues() {
      let ipAddresses = [{ value: '' }]
      let setupTemplateData = JSON.parse(
        JSON.stringify(this.$store.state.createSubbrandStore.setupTemplateData)
      )
      console.log('Setupdatea-->', setupTemplateData)
      if (
        typeof setupTemplateData.config.generalConfig.ipAddresses !==
          'undefined' &&
        setupTemplateData.config.generalConfig.ipAddresses.length > 0
      ) {
        let ips = setupTemplateData.config.generalConfig.ipAddresses
        // Convert String Array to object Array
        ipAddresses = ips.map(value => ({ value }))
      }
      return ipAddresses
    },
    saveEnv() {
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log('All Valid')
        }
      })
      console.log('Save Env')
      console.log(this.errors)
      // Flatten IP address
      var ipAddressList = this.ipAddresses.map(function(item) {
        return item['value']
      })
      // Set Ip address in template data
      this.$store.state.createSubbrandStore.setupTemplateData.config.generalConfig.ipAddresses = ipAddressList

      let subbrandDataObj = this.$store.state.createSubbrandStore
        .setupTemplateData

      console.log('Create Request Obj------>', subbrandDataObj)
      let _channelId = this.$store.state.appStore.selectedChannelId
      let reqObj = {
        channelId: _channelId,
        jsonData: JSON.stringify(subbrandDataObj)
      }
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/create',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          console.log('Sub-brand Data Saved', response.data)
          // Set Cobrand collection refrence Id
          this.$store.state.appStore.selectedSubbrandInfo = response.data
        })
        .catch(error => {
          console.log('Error while saving', error.response.data)
          if (error.response.data.fields) {
            error.response.data.fields.map(key => {
              if (key == 'appext') {
                // APP EXT is not unique
                this.errors.add({
                  field: 'appext',
                  msg: 'Already exists! Please enter a different domain name.'
                })
              }
              if (key == 'name') {
                // Sub-brand name is should be unique
                this.errors.add({
                  field: 'name',
                  msg:
                    'Already exists! Please enter a different Sub-brand name.'
                })
              }
            })
          }
        })
    }
  }
}
</script>

<style>
.main-ctr {
  width: 100%;
  display: block;
}
</style>
